import { CoverImageField } from "./Fields/CoverImageField";

export const DefaultProperties = () => (
  <div className="flex flex-col gap-y-6 px-6">
    <CoverImageField />
  </div>
);
